"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var highContrastMediaQuery = function highContrastMediaQuery(theme) {
  return (theme === null || theme === void 0 ? void 0 : theme.mode) === 'contrast' ? {
    '@media (-ms-high-contrast: active), (forced-colors: active)': {
      forcedColorAdjust: 'none',
      msHighContrastAdjust: 'none'
    }
  } : {};
};
var _default = exports.default = highContrastMediaQuery;